module.exports = __webpack_public_path__ + "img/img_tab_5.b409b1c8.png";